const SubsystemFirmwareTypes = {
    1: "Alpha",
    2: "Beta",
    3: "Release"
};
Object.freeze(SubsystemFirmwareTypes);

export { SubsystemFirmwareTypes }